import { useCampaignInfo } from "@/routes/campaigns/hooks/use-campaign-info";
import { useCampaignId } from "./use-campaign-id";

export function useCurrentCampaignInfo() {
  const id = useCampaignId();

  return useCampaignInfo(id);
}
